import { render } from "./Form2.vue?vue&type=template&id=4b83bff6&scoped=true"
import script from "./Form2.vue?vue&type=script&lang=js"
export * from "./Form2.vue?vue&type=script&lang=js"

import "./Form2.vue?vue&type=style&index=0&id=4b83bff6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b83bff6"]])

export default __exports__